import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, Award, Timer, TrendingUp } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function About() {
  const {
    t
  } = useLanguage();
  const stats = [{
    icon: Award,
    label: t.about.yearsExperience,
    value: '8+'
  }, {
    icon: TrendingUp,
    label: t.about.clientsTransformed,
    value: '500+'
  }, {
    icon: Timer,
    label: t.about.sessionsCompleted,
    value: '10k+'
  }];
  const certifications = [t.about.cert1, t.about.cert2, t.about.cert3];
  return <Section id="about" darker data-id="element-14">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-15">
        {/* Image Side */}
        <div className="relative" data-id="element-16">
          <div className="aspect-[3/4] rounded-sm overflow-hidden bg-brand-gray relative group" data-id="element-17">
            {/* Placeholder for coach image */}
            <div className="absolute inset-0 bg-gray-800 flex items-center justify-center text-gray-600" data-id="element-18">
              <span className="text-lg font-bold uppercase tracking-widest" data-id="element-19">
                {t.about.photoPlaceholder}
              </span>
            </div>
            {/* Overlay gradient */}
            <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/80 to-transparent" data-id="element-20"></div>

            {/* Floating Card */}
            <div className="absolute bottom-6 left-6 right-6 bg-brand-surface/90 backdrop-blur p-6 border-l-4 border-brand-accent" data-id="element-21">
              <p className="font-display text-2xl text-white mb-1" data-id="element-22">
                {t.about.quote}
              </p>
              <p className="text-brand-accent font-bold text-sm uppercase tracking-wider" data-id="element-23">
                {t.about.quoteAuthor}
              </p>
            </div>
          </div>
          {/* Decorative box behind */}
          <div className="absolute -top-4 -right-4 w-full h-full border-2 border-brand-accent/20 -z-10 hidden md:block" data-id="element-24"></div>
        </div>

        {/* Content Side */}
        <div data-id="element-25">
          <h2 className="font-display text-5xl md:text-6xl text-white mb-6" data-id="element-26">
            {t.about.title}{' '}
            <span className="text-brand-accent" data-id="element-27">{t.about.titleAccent}</span>
          </h2>

          <div className="space-y-6 text-gray-400 text-lg leading-relaxed mb-8" data-id="element-28">
            <p data-id="element-29">{t.about.paragraph1}</p>
            <p data-id="element-30">
              {t.about.paragraph2}{' '}
              <strong className="text-white" data-id="element-31">{t.about.paragraph2Bold}</strong> I
              build programs that integrate into your lifestyle, focusing on
              functional strength, mobility, and nutritional balance.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-10" data-id="element-32">
            {stats.map((stat, index) => <div key={index} className="bg-brand-surface p-4 border border-white/5 hover:border-brand-accent/50 transition-colors" data-id="element-33">
                <stat.icon className="w-8 h-8 text-brand-accent mb-3" data-id="element-34" />
                <div className="font-display text-3xl text-white mb-1" data-id="element-35">
                  {stat.value}
                </div>
                <div className="text-xs text-gray-500 uppercase tracking-wider font-bold" data-id="element-36">
                  {stat.label}
                </div>
              </div>)}
          </div>

          <div className="space-y-3" data-id="element-37">
            {certifications.map((cert, i) => <div key={i} className="flex items-center gap-3" data-id="element-38">
                <CheckCircle2 className="w-5 h-5 text-brand-accent flex-shrink-0" data-id="element-39" />
                <span className="text-gray-300 font-medium" data-id="element-40">{cert}</span>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
}